import React from 'react';
import Container from 'react-bootstrap/Container';
import SlideShow from '../../components/slideshow/SlideShow';


function Home() {
	return (

		<Container className='mt-5'>
			<div className="row g-3 justify-content-center align-items-center mb-5 ">
				<div className="col-md-7 col-sm-12">

					<SlideShow></SlideShow>

					<br />

					<h3 className="text-center">O Projeto</h3>

					<p className="text-center">
						O Web Academy é um projeto realizado pela Universidade Federal do Amazonas (UFAM), em
						parceria com a Motorola Mobility Comércio de Produtos Eletrônicos Ltda e Flextronics
						da Amazônia Ltda. O projeto visa a formação de profissionais na área de Desenvolvimento em Web Full
						Stack, com foco em alunos de graduação, pós-graduação e profissionais do mercado
						com curso superior.

					</p>
				</div>

				<div className="col-md-5">

					<div className="row g-3 justify-content-center mb-5">
						<img style={{ minWidth: "7rem", maxWidth: "7rem" }} src="assets/img/ufam_logo.png" className="img-fluid thumbnail" alt="logo ufam" />
						<img style={{ minWidth: "7rem", maxWidth: "9rem" }} src="assets/img/icomp.png" className="img-fluid thumbnail" alt="logo icomp" />
					</div>

					<div className="row g-3 justify-content-center">
						<img style={{ minWidth: "7rem", maxWidth: "7rem" }} src="assets/img/Motorola_logo.svg" className="img-fluid thumbnail" alt="logo motorola" />
						<img style={{ minWidth: "7rem", maxWidth: "10rem" }} id="flexlogo" src="assets/img/flex_logo.png" className="img-fluid thumbnail" alt="logo flextronics" />
					</div>
				</div>

			</div>

			<div className="row g-3 justify-content-center align-items-center">
				<div className="order-1 col-md-5 col-sm-12 order-sm-0">

					<div className="row g-3 justify-content-center mb-5">
						<img style={{ minWidth: "10rem", maxWidth: "12rem" }} src="assets/img/web.png" className="img-fluid" alt="computador com ferramentas web" />
					</div>

				</div>

				<div className="order-0 col-md-7 col-sm-12 order-sm-1">

					<h3 className="text-center">Curso</h3>

					<p className="text-center">
						O objetivo do curso é formar profissionais capacitados em desenvolviemnto web full stack, cobrindo todas as etapas
						do desenvolvimento de uma aplicação de software, com o uso de metodologias e ferramentas modernas.

					</p>
				</div>
			</div>

		</Container>
	)
}

export default Home